/**
 * This will watch a video item for viewport intersection
 * On intersection some elements will be added
 * @example ng-video-item=""
 */

const ngVideoItem = ['$rootScope', () => {
    return {
        link: ( $scope, $item, $params ) => {

            let intersect = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.intersectionRatio > 0) {

                        intersect.unobserve(entry.target);

                        let ul = document.createElement('ul');
                        ul.dataset.vi = "stats";
                        let ol = document.createElement('ul');
                        ol.dataset.vi = "bottom";
                        ol.insertAdjacentHTML('beforeend', '<li data-vi="views"><svg data-vi="eye" width="14" height="14" viewBox="0 0 24 24" width="12"><path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg><span>' + $params.views+ '</span></li>');
                        if ( $params.exclusive === 'true') {
                            ul.insertAdjacentHTML('beforeend', '<li data-vi="star">&#9733;</li>');
                            // ol.insertAdjacentHTML('beforeend', '<li data-vi="badge">Exclusive</li>');
                        }
                        ul.insertAdjacentHTML('beforeend', '<li data-vi="time">' + $params.duration+ '</li>');
                        if ( $params.hd === 'true') {
                            ul.insertAdjacentHTML('beforeend', '<li data-vi="hd">HD</li>');
                        }
                        if ( $params.vr === 'true') {
                            ul.insertAdjacentHTML('beforeend', '<li data-vi="vr">VR</li>');
                        }
                        $item[0].firstElementChild.appendChild(ul);
                        $item[0].firstElementChild.appendChild(ol);
                        //$item[0].appendChild(ol);

                        // Bottom

                    }
                });
            });
            intersect.observe($item[0]);
        }
    }
}];

export default ngVideoItem;

